import {
	MODULE_NAME,
	TRANSACTIONS_HEALTHY,
	SET_TRANSACTIONS_HEALTHY,
	LOADING_ERRORS,
	SET_LOADING_ERRORS
} from './healthy-mutation-types';
import { ApiLogService as api } from '@/services/axiosHelper';
import buildRoute from '@/composables/build-route';

const baseApi = `api/${MODULE_NAME}`;

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: MODULE_NAME,
	namespaced: true,
	state: {
		[TRANSACTIONS_HEALTHY]: {},
		[LOADING_ERRORS]: false
	},
	mutations: {
		// Set TRANSACTIONS_HEALTHY
		[SET_TRANSACTIONS_HEALTHY](state, value) {
			state[TRANSACTIONS_HEALTHY] = value;
		},
		[SET_LOADING_ERRORS](state, value) {
			state[LOADING_ERRORS] = value;
		}
	},
	actions: {
		async [SET_TRANSACTIONS_HEALTHY]({ commit }, params) {
			commit(SET_TRANSACTIONS_HEALTHY, {});
			commit(SET_LOADING_ERRORS, true);
			const results = await api.get(buildRoute(baseApi, params));
			commit(SET_TRANSACTIONS_HEALTHY, results);
			commit(SET_LOADING_ERRORS, false);
		}
	},
	getters: {
		[TRANSACTIONS_HEALTHY]: state => state[TRANSACTIONS_HEALTHY],
		[LOADING_ERRORS]: state => state[LOADING_ERRORS],
		GetErrorPercentage: state => partyId => {
			if (state[TRANSACTIONS_HEALTHY].items) {
				const item = state[TRANSACTIONS_HEALTHY].items.find(
					x => x.partyId === partyId
				);
				if (item?.errorPercentage) {
					return item.errorPercentage;
				}
				return 0;
			}
		}
	}
};
